<div class="content-body">
  <app-breadcrumb [breadcrumb]="breadcrumbList" [addProperty]="canAdd ? 'Add Bank Account' : ''"
      (addEvent)="openAdd()"></app-breadcrumb>

  <div class="container-fluid">
    <div class="card">
      <div class="card-header card-display">
        <div class="row align-items-center w-100">
          <div class="col-md-4">
            <input type="text" class="form-control input-default"
                placeholder="Search by name, account number, IFSC..."
                (input)="onSearchChange($any($event.target).value)" />
          </div>
        </div>
      </div>

      <div class="card-body">
        <div class="table-responsive">
          <table class="table table-hover table-sm">
            <thead>
              <tr>
                <th>Bank Name</th>
                <th>Display Name</th>
                <th>Account Number</th>
                <th>IFSC</th>
                <th>Invoice Format</th>
                <th class="text-end">Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let acc of bankAccounts">
                <td>{{ acc.bank_name }}</td>
                <td>{{ acc.display_name }}</td>
                <td>{{ acc.account_number }}</td>
                <td>{{ acc.ifsc_code }}</td>
                <td><code>{{ acc.invoice_format }}</code></td>
                <td class="text-end">
                  <button class="btn btn-sm btn-outline-secondary me-2"
                      (click)="openView(acc)">View</button>
                  <button *ngIf="canUpdate" class="btn btn-sm btn-outline-primary me-2"
                      (click)="openEdit(acc)">Edit</button>
                  <button *ngIf="canDelete" class="btn btn-sm btn-outline-danger"
                      (click)="remove(acc)">Delete</button>
                </td>
              </tr>
              <tr *ngIf="!bankAccounts.length">
                <td colspan="6" class="text-center text-muted py-3">No bank accounts found</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="dataTables_paginate" *ngIf="pageCount > 1">
          <app-pagination [totalPage]="pageCount" [page]="page" (newPage)="pageChange($event)"></app-pagination>
        </div>
      </div>
    </div>
  </div>

  <div #bankViewModal class="offcanvas offcanvas-end customeoff" tabindex="-1" id="bankViewModal">
    <div class="offcanvas-header">
      <h5 class="modal-title">Bank Account Details</h5>
      <button type="button" class="btn-close" aria-label="Close" (click)="closeView()">
        <i class="fa-solid fa-xmark"></i>
      </button>
    </div>
    <div class="offcanvas-body" *ngIf="viewing">
      <div class="row">
        <div class="col-6 mb-3"><small class="text-muted d-block">Bank Name</small>{{ viewing.bank_name }}</div>
        <div class="col-6 mb-3"><small class="text-muted d-block">Display Name</small>{{ viewing.display_name }}</div>
        <div class="col-6 mb-3"><small class="text-muted d-block">Invoice Name</small>{{ viewing.invoice_name }}</div>
        <div class="col-6 mb-3"><small class="text-muted d-block">GSTIN</small>{{ viewing.gstin || '-' }}</div>
        <div class="col-6 mb-3"><small class="text-muted d-block">Account Name</small>{{ viewing.account_name }}</div>
        <div class="col-6 mb-3"><small class="text-muted d-block">Account Number</small>{{ viewing.account_number }}</div>
        <div class="col-6 mb-3"><small class="text-muted d-block">IFSC Code</small>{{ viewing.ifsc_code }}</div>
        <div class="col-6 mb-3"><small class="text-muted d-block">Branch</small>{{ viewing.branch_name || '-' }}</div>
        <div class="col-6 mb-3"><small class="text-muted d-block">Email</small>{{ viewing.email || '-' }}</div>
        <div class="col-6 mb-3"><small class="text-muted d-block">Phone</small>{{ viewing.phone || '-' }}</div>
        <div class="col-12 mb-3"><small class="text-muted d-block">Address</small>{{ viewing.address || '-' }}</div>
        <div class="col-12 mb-3">
          <small class="text-muted d-block">Invoice ID Format</small>
          <code>{{ viewing.invoice_format }}</code>
        </div>
      </div>

      <hr />
      <div class="d-flex align-items-center justify-content-between mb-2">
        <h6 class="mb-0">Invoice Numbering</h6>
        <button *ngIf="canUpdate" class="btn btn-sm btn-outline-primary" type="button"
            [disabled]="resyncing || sequencesLoading" (click)="recalculateSequences()">
          {{ resyncing ? 'Recalculating…' : 'Recalculate from invoices' }}
        </button>
      </div>
      <div *ngIf="sequencesLoading" class="text-muted">Loading sequences…</div>
      <table class="table table-sm" *ngIf="!sequencesLoading && viewSequences.length">
        <thead>
          <tr>
            <th>Financial Year</th>
            <th>Last Issued</th>
            <th>Next Number</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let seq of viewSequences">
            <td>{{ seq.fy_code }}</td>
            <td>{{ seq.last_issued }}</td>
            <td>{{ seq.next }}</td>
          </tr>
        </tbody>
      </table>
      <div *ngIf="!sequencesLoading && !viewSequences.length" class="text-muted">
        No invoices issued from this bank account yet — numbering starts at 1.
      </div>
      <small class="text-muted d-block mt-1">
        Recalculate re-derives the counters from live invoices. Use it after an invoice was
        removed directly in the database; numbers still held by soft-deleted invoices are never
        reused.
      </small>

      <div class="mt-3">
        <button *ngIf="canUpdate" class="btn btn-primary me-3" type="button" (click)="editFromView()">Edit</button>
        <button class="btn btn-danger" type="button" (click)="closeView()">Close</button>
      </div>
    </div>
  </div>

  <div #bankAccountModal class="offcanvas offcanvas-end customeoff" tabindex="-1" id="bankAccountModal">
    <div class="offcanvas-header">
      <h5 class="modal-title">{{ editingUid ? 'Edit Bank Account' : 'Add Bank Account' }}</h5>
      <button type="button" class="btn-close" aria-label="Close" (click)="close()">
        <i class="fa-solid fa-xmark"></i>
      </button>
    </div>
    <div class="offcanvas-body">
      <form [formGroup]="form" (ngSubmit)="submit()" autocomplete="off">
        <div class="row">
          <div class="col-xl-6 mb-3">
            <label class="form-label">Bank Name<span class="text-danger">*</span></label>
            <input type="text" class="form-control" formControlName="bank_name" />
          </div>
          <div class="col-xl-6 mb-3">
            <label class="form-label">GSTIN</label>
            <input type="text" class="form-control" formControlName="gstin" />
          </div>
          <div class="col-xl-6 mb-3">
            <label class="form-label">Display Name<span class="text-danger">*</span></label>
            <input type="text" class="form-control" formControlName="display_name" />
          </div>
          <div class="col-xl-6 mb-3">
            <label class="form-label">Invoice Name<span class="text-danger">*</span></label>
            <input type="text" class="form-control" formControlName="invoice_name" />
          </div>
          <div class="col-xl-12 mb-3">
            <label class="form-label">Invoice ID Format<span class="text-danger">*</span></label>
            <input #invoiceFormatInput type="text" class="form-control"
                formControlName="invoice_format" spellcheck="false" />
            <div class="mt-1">
              <button type="button" class="btn btn-outline-secondary btn-sm me-1 mb-1"
                  *ngFor="let ph of formatPlaceholders" (click)="insertPlaceholder(ph)">
                {{ ph }}
              </button>
            </div>
            <small class="text-muted d-block" *ngIf="formatPreview">
              Preview: <strong>{{ formatPreview }}</strong>
            </small>
            <div class="text-danger" *ngIf="formatErrorMessage">{{ formatErrorMessage }}</div>
            <small class="text-muted d-block" *ngIf="editingUid">
              Changing the format affects future invoices only; already issued invoice IDs and
              numbering are not changed.
            </small>
          </div>
          <div class="col-xl-6 mb-3">
            <label class="form-label">Account Name<span class="text-danger">*</span></label>
            <input type="text" class="form-control" formControlName="account_name" />
          </div>
          <div class="col-xl-6 mb-3">
            <label class="form-label">Account Number<span class="text-danger">*</span></label>
            <input type="text" class="form-control" formControlName="account_number" />
          </div>
          <div class="col-xl-6 mb-3">
            <label class="form-label">IFSC Code<span class="text-danger">*</span></label>
            <input type="text" class="form-control" formControlName="ifsc_code" />
          </div>
          <div class="col-xl-6 mb-3">
            <label class="form-label">Branch Name</label>
            <input type="text" class="form-control" formControlName="branch_name" />
          </div>
          <div class="col-xl-6 mb-3">
            <label class="form-label">Email</label>
            <input type="email" class="form-control" formControlName="email" />
          </div>
          <div class="col-xl-6 mb-3">
            <label class="form-label">Phone</label>
            <input type="text" class="form-control" formControlName="phone" />
          </div>
          <div class="col-xl-12 mb-3">
            <label class="form-label">Address</label>
            <textarea class="form-control" rows="2" formControlName="address"></textarea>
          </div>
          <div class="col-xl-12 mb-3">
            <label class="form-label">Logo URL</label>
            <input type="text" class="form-control" formControlName="logo" />
          </div>
        </div>
        <div>
          <button class="btn btn-primary ms-1 me-3" type="submit"
              [disabled]="form.invalid || loadingService.isLoading()">
            {{ editingUid ? 'Update' : 'Save' }}
          </button>
          <button class="btn btn-danger" type="button" (click)="close()">Cancel</button>
        </div>
      </form>
    </div>
  </div>
</div>
